import api from './axiosApi'
import type {
  DropdownAdminOption,
  DropdownOptionCreatePayload,
  DropdownOptionUpdatePayload,
  DropdownOptionUsage,
} from '@/types/adminDropdowns'

interface DropdownOptionListResponse {
  items: DropdownAdminOption[]
}

export async function listAdminDropdownCategories(): Promise<string[]> {
  const { data } = await api.get<string[]>('/admin/dropdown-options/categories')
  return data
}

export async function listAdminDropdownOptions(
  category: string
): Promise<DropdownAdminOption[]> {
  const { data } = await api.get<DropdownOptionListResponse>(
    `/admin/dropdown-options/${category}`
  )
  return data.items
}

export async function createAdminDropdownOption(
  category: string,
  payload: DropdownOptionCreatePayload
): Promise<DropdownAdminOption> {
  const { data } = await api.post<DropdownAdminOption>(
    `/admin/dropdown-options/${category}`,
    payload
  )
  return data
}

export async function updateAdminDropdownOption(
  category: string,
  id: string,
  payload: DropdownOptionUpdatePayload
): Promise<DropdownAdminOption> {
  const { data } = await api.patch<DropdownAdminOption>(
    `/admin/dropdown-options/${category}/${id}`,
    payload
  )
  return data
}

export async function deleteAdminDropdownOption(
  category: string,
  id: string
): Promise<void> {
  await api.delete(`/admin/dropdown-options/${category}/${id}`)
}

export async function getDropdownOptionUsage(
  category: string,
  value: string
): Promise<DropdownOptionUsage> {
  const { data } = await api.get<DropdownOptionUsage>(
    `/admin/dropdown-options/${category}/usage/${encodeURIComponent(value)}`
  )
  return data
}

export async function reorderAdminDropdownOptions(
  category: string,
  orderedIds: string[]
): Promise<DropdownAdminOption[]> {
  const { data } = await api.put<DropdownOptionListResponse>(
    `/admin/dropdown-options/${category}/reorder`,
    { ordered_ids: orderedIds }
  )
  return data.items
}
